import {Component, OnInit} from '@angular/core';
import {InvoiceTemplateBase} from '../invoce-template-base';

@Component({
    selector: 'eci-final-purchase-invoice-form',
    templateUrl: './final-purchase-invoice-form.component.html',
    styleUrls: ['./final-purchase-invoice-form.component.scss']
})
export class FinalPurchaseInvoiceFormComponent extends InvoiceTemplateBase implements OnInit {

    ngOnInit(): void {
        this.model = {
            ...this.template,
            ...this.invoice,
            customerCompany: {
                ...this.template.customerCompany,
                ...this.invoice.customerCompany
            }
        };
    }

}
